import { AssetViewer } from '@/components/AssetViewer/AssetViewer';
import { useGetAsset } from '@/hooks/api/assets/useGetAsset';
import { usePageTitle } from '@/hooks/usePageTitle';
import { getAssetName } from '@/utils/assets';
import { useParams } from 'react-router-dom';

export const AssetPage = () => {
  const { assetId } = useParams();
  const { asset } = useGetAsset({ assetId });

  const pageTitle = asset ? `${getAssetName(asset)}` : 'Asset';
  usePageTitle(pageTitle);

  return <AssetViewer assetId={assetId} />;
};
